import styled from "styled-components";

export const StyledFrontOfficePage = styled.div`
  width: 100%;
  height: 100vh;
  font-family: ${(props) => props.theme["settings.general.font.family"]},
    sans-serif;
  font-size: ${(props) => props.theme["settings.general.font.size"]}px;
`;
